import script from "./Subheading.vue?vue&type=script&setup=true&lang=js"
export * from "./Subheading.vue?vue&type=script&setup=true&lang=js"

import "./Subheading.vue?vue&type=style&index=0&id=70a6cf2f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70a6cf2f"]])

export default __exports__